import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { ICase } from '../../../models/case.interface';
import { SaveCaseMutation } from '../../../graphql/mutations/case.mutation';
import { CaseApiService } from '../case-api.service';

@Injectable({
    providedIn: 'root'
  })
export class CaseGqlService implements CaseApiService {
  constructor(
    private apollo: Apollo
  ) { }

  public saveCase(incident: ICase, program: string, name: string): Observable<ICase[]> {
    console.log(`CaseGql.saveCase()`);
    return this.apollo
      .mutate({
        mutation: SaveCaseMutation,
        variables : {
          incident,
          program,
          name
        }
      })
      .pipe(map(result => result.data['saveCase'] as ICase[]), take(1));
  }

}
